/* eslint-disable import/prefer-default-export */
import { isValidVRM, unprettyVRM } from 'Utilities/formValidators';

import { Vehicle } from './@types';

export const findVehicleByVrm = (vehicles: Vehicle[], vrm: string) => {
  const validVRM = vrm && isValidVRM(vrm) && unprettyVRM(vrm);
  return vehicles.find(((vehicle) => vehicle.vrm === validVRM));
};
